module.exports = __webpack_public_path__ + "img/jt2.e35999cb.png";